import { render, staticRenderFns } from "./PublicCallback.vue?vue&type=template&id=5f8dbfa3"
import script from "./PublicCallback.vue?vue&type=script&lang=js"
export * from "./PublicCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports